import store from "../store";

export const statusActionTypes = {
  SET_ERROR_STATUS: "SET_ERROR_STATUS",
  SET_SUCCESS_STATUS: "SET_SUCCESS_STATUS",
  CLEAR_STATUS: "CLEAR_STATUS"
};

export function setErrorStatus(payload) {
  store.dispatch({ type: statusActionTypes.SET_ERROR_STATUS, payload });
}

export function setSuccessStatus(message) {
  store.dispatch({
    type: statusActionTypes.SET_SUCCESS_STATUS,
    payload: { message, code: "success" }
  });
}

export function removeStatus() {
  store.dispatch({ type: statusActionTypes.CLEAR_STATUS });
}
